<template>
  <v-container
    id="acc_ctrl-Org-list"
    tag="section"
  >
    <v-row class="d-flex justify-center">
      <v-col
        cols="12"
      >
        <base-material-card
          v-if="show"
          icon="mdi-target"
          inline
          class="px-5 py-3"
          min-height="230"
        >
          <template v-slot:after-heading>
            <div class="text-h3 font-weight-light">
              Initiative Setting
            </div>
          </template>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            class="ml-auto"
            label="Search"
            hide-details
            single-line
            style="max-width: 320px;"
            @input="reload()"
          />
          <v-container>
            <v-row align="start">
              <v-col
                class="d-flex py-2"
                cols="12"
                sm="6"
                md="3"
              >
                <v-autocomplete
                  v-model="selectedCountry"
                  :items="countryOptions"
                  label="Country"
                  dense
                  outlined
                  persistent-hint
                  hide-details
                  class="text-body-2"
                  :loading="!this.status.init"
                  :disabled="!this.status.init"
                />
              </v-col>
              <!-- <v-col
                class="d-flex py-2"
                cols="12"
                sm="6"
                md="3"
              >
                <v-select
                  v-model="selectedParent"
                  :items="parentGroup"
                  :label="'Category' + ((selectedParent.value && selectedParent.value.length) ? '' : ':All')"
                  dense
                  outlined
                  chips
                  persistent-hint
                  hide-details
                  class="text-body-2"
                />
              </v-col> -->
              <v-col
                class="d-flex py-2"
                cols="12"
                sm="6"
                md="3"
              >
                <v-autocomplete
                  v-model="selectName"
                  :items="nameList"
                  :label="'Initiative Name' + ((selectName && selectName.length) ? '' : ':All')"
                  dense
                  outlined
                  multiple
                  chips
                  persistent-hint
                  hide-details
                  class="text-body-2"
                />
              </v-col>
            </v-row>
          </v-container>
          <v-data-table
            v-if="update"
            class="mt-4 ml-3 v-table-width table-odd-even-row"
            :headers="headers"
            :items="filterData"
            :loading="!isLoaded"
            :search="search"
            :items-per-page="10"
            fixed-header
            height = "593"
          >
            <template
              v-slot:item.btn="{ item }"
            >
              <!-- # ms - add class width height -->
              <v-btn
                v-if="item.canEdit"
                icon
                class="mx-1 success lighten-1"
                width="36"
                height="36"
                @click="clickUpdateAim(item)"
              >
                <v-icon style="font-size:25px">
                  edit
                </v-icon>
              </v-btn>
            </template>
          </v-data-table>
            <p />
            <v-row
              align="end"
              justify="end"
            >
              <v-btn
                tile
                color="success"
                @click="clickAddAim"
              >
                Add Initiative
              </v-btn>
            </v-row>
        </base-material-card>
        <div v-else>
          <v-row
            class="mx-auto"
            justify="space-around"
          >
            <v-col
              cols="auto"
              class="text-center"
            >
              <v-progress-circular
                :size="96"
                :width="8"
                color="primary"
                indeterminate
              />
              <p class="text-subtitle-1 mt-5">
                Loading...
              </p>
            </v-col>
          </v-row>
        </div>
      </v-col>
    </v-row>
    <v-snackbar
      v-model="snackbar"
      :timeout="4000"
      :color="snackbarColor"
      top
    >
      <v-btn
        text
        @click="snackbar = false"
      >
        Close
      </v-btn>
    </v-snackbar>
    <v-dialog
      :value="isAimUpdating"
      persistent
      min-width="550px"
      max-width="550px"
    >
      <v-card>
        <v-card-title>
          <div style="width:100%;display:flex;vertical-align:center;">
            <div style="flex:1;text-align:left;font-weight: 500;">
              Initiative Setting
            </div>
            <v-icon
              class="mt-3"
              size="18"
              @click="clickCloseAimUpdate"
            >
              mdi-close
            </v-icon>
          </div>
        </v-card-title>
        <v-card-text>
          <v-form
            v-model="isUpdatingUserValid"
            lazy-validation
          >
            <v-row class="mx-1">
              <v-col
                cols="12"
                class="px-0 py-1"
              >
                <div 
                  class="ml-0 mb-2 font-weight-bold"
                  style="float:left;"
                >
                  Country:
                </div>
                <div
                  class="ml-0 mb-2 font-weight-bold success--text"
                  style="float:right;"
                >
                  {{ selectItem.country }}
                </div>
              </v-col>
            </v-row>
            <v-row class="mx-1">
              <v-col
                cols="12"
                class="px-0 py-1"
              >
                <div 
                  class="ml-0 mb-2 font-weight-bold"
                  style="float:left;"
                >
                  Initiative Name
                </div>
                <div
                  class="ml-0 mb-2 font-weight-bold success--text"
                  style="float:right;"
                >
                  {{ selectItem.name }}
                </div>
              </v-col>
            </v-row>
            <v-row class="mx-1">
              <v-col
                cols="12"
                class="px-0 py-1"
              >
                <div 
                  class="ml-0 mb-2 font-weight-bold"
                  style="float:left;"
                >
                  Initiative Code
                </div>
                <div
                  class="ml-0 mb-2 font-weight-bold success--text"
                  style="float:right;"
                >
                  {{ selectItem.code }}
                </div>
              </v-col>
            </v-row>
            <v-row class="mx-1">
              <v-col
                cols="12"
                class="px-0 py-1"
              >
                <div 
                  class="ml-0 mb-2 font-weight-bold"
                  style="float:left;"
                >
                  Category
                </div>
                <div
                  class="ml-0 mb-2 font-weight-bold success--text"
                  style="float:right;"
                >
                  {{ selectItem.parent}}
                </div>
              </v-col>
            </v-row>
            <v-row class="mx-1">
              <v-col
                cols="12"
                class="px-0 py-1"
              >
                <div class="ml-0 mb-2 font-weight-bold">
                  Introduction
                </div>
                <v-text-field
                  v-model="selectItem.intro"
                  solo
                  dense
                  hide-details
                />
              </v-col>
            </v-row>
            <v-row class="mx-1">
              <v-col
                cols="12"
                class="px-0 py-1"
              >
                <div class="ml-0 mb-2 font-weight-bold">
                  EPM Account (Default All)
                </div>
                <v-select
                  v-model="selectItem.epm_acc"
                  :items="epmGroup"
                  :label="'EPM Account' + ((selectItem.epm_acc && selectItem.epm_acc) ? '' : ': All' )"
                  dense
                  return-object
                  outlined
                  multiple
                  chips
                  deletable-chips
                  persistent-hint
                  hide-details
                >
                  <template v-slot:prepend-item>
                    <v-list-item
                      ripple
                      @click="toggle()"
                    >
                      <v-list-item-action>
                        <v-icon :color="selectItem.epm_acc > 0 ? 'indigo darken-4' : ''">{{ icon }}</v-icon>
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title>Select All</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider class="mt-2"></v-divider>
                  </template>
                </v-select>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions class="pa-5 pt-3">
          <v-spacer />
          <v-btn
            color="red"
            text
            @click="clickCloseAimUpdate"
          >
            Cancel
          </v-btn>
          <v-btn
            color="primary"
            class="ma-0"
            @click="openDialog"
          >
            Done
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      :value="isAddInitiative"
      persistent
      min-width="550px"
      max-width="550px"
    >
      <v-card>
        <v-card-title>
          <div style="width:100%;display:flex;vertical-align:center;">
            <div style="flex:1;text-align:left;font-weight: 500;">
              Initiative Setting
            </div>
            <v-icon
              class="mt-3"
              size="18"
              @click="clickCloseAimAdd"
            >
              mdi-close
            </v-icon>
          </div>
        </v-card-title>
        <v-card-text>
          <v-form
            v-model="isUpdatingUserValid"
            lazy-validation
          >
            <v-row class="mx-1">
              <v-col
                cols="12"
                class="px-0 py-1"
              >
                <div 
                  class="ml-0 mb-2 font-weight-bold"
                  style="float:left;"
                >
                  Country:
                </div>
                <div
                  class="ml-0 mb-2 font-weight-bold success--text"
                  style="float:right;"
                >
                  {{ selectedCountry }}
                </div>
              </v-col>
            </v-row>
            <v-row class="mx-1">
              <v-col
                cols="12"
                class="px-0 py-1"
              >
                <div class="ml-0 mb-2 font-weight-bold">
                  Initiative Name
                </div>
                <v-autocomplete
                  v-model="addItem.name"
                  :items="aimList.map(el => 
                    el.name
                  )"
                  solo
                  dense
                  hide-details
                />
              </v-col>
            </v-row>
            <v-row class="mx-1">
              <v-col
                cols="12"
                class="px-0 py-1"
              >
                <div 
                  class="ml-0 mb-2 font-weight-bold"
                  style="float:left;"
                >
                  Initiative Code
                </div>
                <div
                  class="ml-0 mb-2 font-weight-bold success--text"
                  style="float:right;"
                >
                  {{ aimName[addItem.name] }}
                </div>
              </v-col>
            </v-row>
            <v-row class="mx-1">
              <v-col
                cols="12"
                class="px-0 py-1"
              >
                <div 
                  class="ml-0 mb-2 font-weight-bold"
                  style="float:left;"
                >
                  Category
                </div>
                <div
                  class="ml-0 mb-2 font-weight-bold success--text"
                  style="float:right;"
                >
                  {{ "Initiative" }}
                </div>
                <!-- <v-select
                  v-model="addItem.parent"
                  :items="parentGroup"
                  outlined
                /> -->
              </v-col>
            </v-row>
            <v-row class="mx-1">
              <v-col
                cols="12"
                class="px-0 py-1"
              >
                <div class="ml-0 mb-2 font-weight-bold">
                  Introduction
                </div>
                <v-text-field
                  v-model="addItem.intro"
                  solo
                  dense
                  hide-details
                />
              </v-col>
            </v-row>
            <v-row class="mx-1">
              <v-col
                cols="12"
                class="px-0 py-1"
              >
                <div class="ml-0 mb-2 font-weight-bold">
                  EPM Account (Default All)
                </div>
                <v-select
                  v-model="addItem.epm_acc"
                  :items="epmGroup"
                  :label="'EPM Account' + ((addItem.epm_acc && addItem.epm_acc) ? '' : ': All' )"
                  dense
                  return-object
                  outlined
                  multiple
                  chips
                  deletable-chips
                  persistent-hint
                  hide-details
                >
                  <template v-slot:prepend-item>
                    <v-list-item
                      ripple
                      @click="toggleAdd()"
                    >
                      <v-list-item-action>
                        <v-icon :color="addItem.epm_acc > 0 ? 'indigo darken-4' : ''">{{ iconAdd }}</v-icon>
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title>Select All</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider class="mt-2"></v-divider>
                  </template>
                </v-select>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions class="pa-5 pt-3">
          <v-spacer />
          <v-btn
            color="red"
            text
            @click="clickCloseAimAdd"
          >
            Cancel
          </v-btn>
          <v-btn
            color="primary"
            class="ma-0"
            @click="clickDoneAddAim"
          >
            Add
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      :value="isUserSaving"
      persistent
      min-width="900px"
      max-width="900px"
    >
      <v-card>
        <v-card-title>
          <div style="width:100%;display:flex;vertical-align:center;">
            <div style="flex:1;text-align:left;font-weight:600;">
              WARNING: CHANGE INITIATIVE WILL DELETE ALL RELATED SAVED DATA!
              ARE YOU SURE TO CHANGE INITIATIVE? (Will take 10s to reload data)
            </div>
          </div>
        </v-card-title>
        <v-card-actions class="pa-5 pt-3">
          <v-spacer />
          <v-btn
            color="red"
            text
            @click="closeDialog"
          >
            Close
          </v-btn>
          <v-btn
            color="primary"
            class="ma-0"
            @click="clickDoneUpdateAim"
          >
            Change
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import { mapState } from 'vuex'
  import { xPost } from '@/http/axios'
  import { setUserSelectInfo, getUserSelectInfo, removeUserSelectInfo } from '@/functions/cookie'
  export default {
    components: {
      // # ms - change
      // -----------------------
      PoptipProfile: () => import('@/components/poptip-profile-v3'),
      dialogComments: () => import('@/components/dialog/comments'),
      autocompleteAccountMs: () => import('@/components/autocomplete-account-ms')
      // -----------------------
    },
    data () {
      return {
        myDom: {
          params: {},
        },
        headers: [
          {
            class: 'black white--text text-body-1',
            text: 'Country',
            value: 'country',
            width: 100
          },
          {
            class: 'black white--text text-body-1',
            text: 'Initiative Code',
            value: 'code',
            width: 120
          },
          {
            class: 'black white--text text-body-1',
            text: 'Initiative Name',
            value: 'name',
            width: 150
          },
          {
            class: 'black white--text text-body-1',
            text: 'Category',
            value: 'parent',
            width: 30,
            sortable: false
          },
          {
            class: 'black white--text text-body-1',
            text: 'Introduction',
            value: 'intro',
            width: 120
          },
          {
            class: 'black white--text text-body-1',
            text: 'EPM Account',
            value: 'epm_acc',
            width: 120
          },
          {
            class: 'black white--text text-body-1',
            text: 'Action',
            value: 'btn',
            width: 50,
            sortable: false
          },
        ],
        status: {
          init: false,
          saving: false,
          change: null,
          loading: false,
          rowFocused: -1,
          save: {
            done: false,
            text: ''
          }
        },
        loading: true,
        dataTime: null,
        timeGetData: null,
        // parentGroup: ['Initiative', 'M&A'],
        epmGroup: [],
        aimData: {
          id: '',
          name: '',
          code: '',
          country: '',
          parent: '',
          epm_acc: [''],
          intro: '',
          canEdit: false,
        },
        filterData: [],
        selectItem: [],
        selectAll: null,
        selectAllAdd: null,
        selectName: [],
        nameList:[],
        aimList: [],
        aimName: [],
        countryOptions: [],
        // selectedParent: [],
        selectedCountry: null,
        addItem: {
          name:'',
          code:'',
          parent: 'Initiative',
          intro: '',
          epm_acc: [],
        },
        isLoaded: false,
        snackbar: false,
        snackbarMessage: null,
        snackbarColor: null,
        search: '',
        userRole: '',
        isAimUpdating: false,
        isUpdatingUserValid: true,
        // isConfirmingDelete: false,
        // deleteIndex: null,
        // country: [],
        // accessCountry: [],
        isAddInitiative: false,
        update: false,
        show: false,
        page: 1,
        isUserSaving: false,
      }
    },
    computed: {
      ...mapState(['user']),
      // AddParentGroup () {
      //   if (isAddInitiative) {
      //     return "Initiative"
      //   } else {
      //     return "M&A"
      //   }
      // },
      myDB () {
        return this.lodash.get(this.myDom, ['params', 'db']) || ''
      },
      icon () {
        if (typeof this.selectItem.epm_acc === 'undefined') {
          return 'mdi-checkbox-blank-outline'
        }
        else if (this.selectItem.epm_acc.length === this.epmGroup.length) {
          this.selectAll = true
        } else {
          this.selectAll = false
        }
        if (this.selectAll) {
          return 'mdi-checkbox-marked'
        }
        return 'mdi-checkbox-blank-outline'
      },
      iconAdd () {
        if (this.addItem.epm_acc === this.epmGroup) {
          this.selectAllAdd = true
        } else {
          this.selectAllAdd = false
        }
        if (this.selectAllAdd) {
          return 'mdi-checkbox-marked'
        }
        return 'mdi-checkbox-blank-outline'
      },
    },
    beforeMount () {
      this.myDom.params = this.$route.meta instanceof Object ? this.$route.meta : {}
      this.$eventBus.$emit('check-access')
      this.init()
    },
    mounted () {
      window.scrollTo(0, 0)
      // this.refreshAll()
    },
    methods: {
      // getRoleTypes (item) {
      //   return item.roleType
      //     .map(el => (this.roleTypeGroup.find(el2 => el2.value === el) || {}).text || '')
      //     .filter(el => el)
      //     .join(', ')
      // },
      async init () {
        await this.postGetUserCountries()
        this.setDefaultParams()
      },
      clearAll () {
        this.loading = false
        this.aimData = {
          id: '',
          name: '',
          code: '',
          country: '',
          parent: '',
          epm_acc: [],
          intro: '',
        }
        this.aimList = []
        this.aimName = []
        // this.selectName = []
      },
      clickCloseAimUpdate () {
        this.closeUpdateAimDialog()
        this.refreshAll()
      },
      closeUpdateAimDialog () {
        this.isAimUpdating = false
      },
      clickCloseAimAdd () {
        this.closeAddAimDialog()
        this.refreshAll()
      },
      closeAddAimDialog () {
        this.isAddInitiative = false
      },
      clickUpdateAim (item) {
        this.selectItem = []
        if (item.epm_acc === 'All') {
          item.epm_acc = []
        }
        this.selectItem = item
        this.isAimUpdating = true
      },
      clickAddAim () {
        this.addItem.name = ''
        this.addItem.code = ''
        this.addItem.parent = 'Initiative'
        this.addItem.intro = ''
        this.addItem.epm_acc = []
        this.isAddInitiative = true
      },
      clickDoneUpdateAim () {
        this.postUpdateAim()
      },
      clickDoneAddAim () {
        this.postAddAim()
      },
      // async refreshData (dataTime) {
      //   if (!dataTime) {
      //     dataTime = new Date()
      //     this.dataTime = dataTime
      //   } else {
      //     if (this.dataTime !== dataTime) { 
      //       this.loading = true
      //       return
      //     }
      //   }
        
      //   const getData = this.GetData()
      //   await getData
      // },
      async GetData (dataTime) {
        setUserSelectInfo('aim_country', JSON.stringify(this.selectedCountry))
        this.isLoaded = false
        this.epmGroup = []
        // let parentData = []
        let nameData = []
        // if (this.selectedParent.length == 0 || this.selectedParent.length == 2) {
        //   parentData = 1
        // } else if (this.selectedParent.length == 1) {
        //   parentData = 'w2.`name` = "' + this.selectedParent + '"'
        // }
        // if (this.selectName.length == 0 || this.selectName.length == this.nameList.length) {
        //   nameData = 1
        // } else {
        //   nameData = 'w1.`name` in ("' + this.selectName + '")'
        // }
        // console.log(nameData)
        try {
          const params = {
            userinfo: this.user,
            db: this.myDB,
            country: this.selectedCountry,
            // parent: parentData,
            // nameData: nameData,
          }
          const req = xPost(
            'aim',
            'getData',
            params)
          const res = await req
          switch (this.myDB){
            case 'international': 
              this.userRole = this.user.Role
              break
            case 'CI':
              this.userRole = this.user.CI_Role
              break
            case 'Bases':
              this.userRole = this.user.Bases_Role
              break
            default:
              break
          }
          if (res.status === 200 && res.data.status === 200) {
            this.aimData = res.data.aims.map(el => ({
              id: el.Id,
              country: el.country,
              code: el.INITIATIVECODE,
              name: el.name,
              parent: el.parent,
              intro: el.intro,
              epm_acc: el.epm_filter === '' ? 'All' : el.epm_filter.split(","),
              canEdit: this.checkCanEdit(this.userRole),
            }))
            this.aimList = res.data.aimcode.map(el => ({
              code: el.INITIATIVECODE,
              name: el.INITIATIVENAME,
            }))
            this.aimName = []
            res.data.aimcode.forEach(el => {
              this.aimName[el.INITIATIVENAME] = el.INITIATIVECODE
            })
            this.nameList = this.aimData.map(el => 
              el.name
            )
            // console.log(this.aimList.map(el => 
            //         el.name
            //       ))
            this.epmGroup = res.data.epms.map(el =>
              el.epm_acc
            )
            this.filterData = []
            for (const filter of this.aimData) {
              const value = this.selectName.filter(el => el === filter.name)
              if (value.length !== 0) {
                this.filterData.push(filter)
              }
            }
            // console.log(this.filterData)
            if (this.selectName.length === 0 || this.selectName.length == this.nameList.length) {
              this.filterData = this.aimData
            }
          }
        } catch (err) {
          console.log(err)
          this.snackbarMessage = "can't get aim data"
          this.snackbar = true
          this.snackbarColor = 'error'
          // this.confirmUploading = false
        }
        this.status.init = true
        this.reload()
        this.show = true
        this.isLoaded = true
        this.loading = true
      },
      async postUpdateAim () {
        try {
          const params = { 
              userinfo: this.user,
              id: this.selectItem.id,
              country: this.selectItem.country,
              parent: this.selectItem.parent,
              // code: this.selectItem.code,
              epm_acc: Array.isArray(this.selectItem.epm_acc) ? this.selectItem.epm_acc.join(',') : this.selectItem.epm_acc,
              intro: this.selectItem.intro
            }
          const req = xPost(
            'aim',
            'updateData',
            params)
          const res = await req
        } catch (err) {
            console.log(err)
            this.snackbarMessage = "can't save"
            this.snackbar = true
            this.snackbarColor = 'error'
        }
        this.isUserSaving = false
        this.clickCloseAimUpdate()
      },
      async postAddAim () {
        try {
          const params = { 
              userinfo: this.user,
              country: this.selectedCountry,
              name: this.addItem.name,
              code: this.aimName[this.addItem.name],
              parent: this.addItem.parent,
              epm_acc: this.addItem.epm_acc.join(','),
              intro: this.addItem.intro
            }
          // console.log(params)
          const req = xPost(
            'aim',
            'addData',
            params)
          const res = await req
        } catch (err) {
            console.log(err)
            this.snackbarMessage = "can't add"
            this.snackbar = true
            this.snackbarColor = 'error'
        }
        this.clickCloseAimAdd()
      },
      async refreshAll () {
        this.selectItem = []
        this.isLoaded = false
        this.dataTime = new Date()
        await this.GetData(this.dataTime)
        this.show = true
        this.isLoaded = true
      },
      async postGetUserCountries () {
        const params = {
          userinfo: this.user,
          db: this.myDB,
        }
        try {
          const res = await xPost(
            'params',
            'user_countries',
            params
          )
          if (res.status === 200 && res.data.countries instanceof Array) {
            this.countryOptions = res.data.countries || []
            if ((this.userRole === '-1' || this.userRole === '0') && !this.countryOptions.includes('CI')) {
              this.countryOptions.push('CI')
            }
            if ((this.userRole === '-1' || this.userRole === '0') && !this.countryOptions.includes('BASES')) {
              this.countryOptions.push('BASES')
            }
            this.mapRegionCountryEntity = (res.data.mapRCE || []).filter(el => this.countryOptions.includes(el.country))
          }
        } catch (err) {
          console.log("can't get user countries: ")
          console.log(err)
        }
      },
      reload () {
        this.update = false
        this.$nextTick(() => {
          this.update = true
        })
      },
      checkCanEdit (role) {
        if (this.userRole === '-1' || this.userRole === '0') {
          return true
        } else {
          return false
        }
      },
      // async getAimData (dataTime) {
      //   if (this.dataTime !== dataTime) { 
      //     this.loading = true
      //     return
      //   }
      //   this.loading = true
      //   // await getRate
      //   const refreshData = this.refreshData(dataTime)
      //   await refreshData

      //   this.status.init = true
      // },
      setDefaultParams () {
        if (typeof getUserSelectInfo('aim_country') === 'undefined') {
          this.selectedCountry = this.countryOptions[0]
        } else {            
          const selectedCountry = getUserSelectInfo('aim_country')
          this.selectedCountry = ['{', '[', '"', "'"].includes(selectedCountry[0]) ? JSON.parse(selectedCountry) : selectedCountry
        }
      },
      openDialog () {
        this.isUserSaving = true
      },
      closeDialog () {
        this.isUserSaving = false
      },
      toggle () {
        this.$nextTick(async () => {
          if (this.selectAll) {
            this.selectAll = true
            this.selectItem.epm_acc = []
          } else {
            this.selectAll = false
            this.selectItem.epm_acc = this.epmGroup
          }
        }
        ) 
      },
      toggleAdd () {
        this.$nextTick(async () => {
          if (this.selectAllAdd) {
            this.selectAllAdd = true
            this.addItem.epm_acc = []
          } else {
            this.selectAllAdd = false
            this.addItem.epm_acc = this.epmGroup
          }
        }
        ) 
      },
    },
    watch: {
      selectedCountry: {
        deep: true,
        handler (nv, ov) {
          this.dataTime = new Date()
          if (nv === ov) { return }
          this.selectedCountry = nv
          if (this.status.init) { this.clearAll() }
          let timeGetData = new Date()
          this.timeGetData = timeGetData
          setTimeout(async () => {
              if (this.timeGetData === timeGetData) { await this.GetData(this.dataTime) }
          }, 100)
        }
      },
      // selectedParent: {
      //   deep: true,
      //   handler (nv, ov) {
      //     this.dataTime = new Date()
      //     if (nv === ov) { return }
      //     this.selectedParent = nv
      //     if (this.status.init) { this.clearAll() }
      //     let timeGetData = new Date()
      //     this.timeGetData = timeGetData
      //     setTimeout(async () => {
      //         if (this.timeGetData === timeGetData) { await this.GetData(this.dataTime) }
      //     }, 100)
      //   }
      // },
      selectName: {
        deep: true,
        handler (nv, ov) {
          this.dataTime = new Date()
          if (nv === ov) { return }
          this.selectName = nv
          if (this.status.init) { this.clearAll() }
          let timeGetData = new Date()
          this.timeGetData = timeGetData
          setTimeout(async () => {
              if (this.timeGetData === timeGetData) { await this.GetData(this.dataTime) }
          }, 100)
        }
      },
    }
  }
</script>

<style lang="sass">
  .v-data-table table thead tr th
    font-size: 14px !important

  .v-btn--icon.v-size--default
    height: auto
    min-width: auto

  .v-table-width
    tbody tr td
      max-width: 200px !important
  
  .table-odd-even-row
  tbody
    tr:nth-child(odd)
      td
        background-color: #eeeeee
    tr:nth-child(even)
      td
        background-color: #d5d5d5
</style>
